import { useLazyQuery } from '@apollo/client/react';
import { useEffect, useMemo } from 'react';

import { GetDraftAppointmentOnInsuranceCardDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

type Props = {
  draftAppointmentId: string | null;
};

export const useFetchDraftAppointment = ({ draftAppointmentId }: Props) => {
  const [getDraftAppointment, { data, loading }] = useLazyQuery(
    GetDraftAppointmentOnInsuranceCardDocument,
  );

  const draftAppointment = useMemo(() => {
    return getNode(data, 'DraftAppointment');
  }, [data]);

  useEffect(() => {
    if (draftAppointmentId) {
      getDraftAppointment({
        variables: {
          id: draftAppointmentId,
        },
      });
    }
  }, [draftAppointmentId, getDraftAppointment]);

  return {
    isActivePatient: !!draftAppointment?.patient?.active,
    loading,
  };
};
